module.exports = __webpack_public_path__ + "4c33668d77575ae90cccce037952055e.png";